/**
 * Chatbot - Persistance de session de la conversation.
 *
 * Chaque page du BackOffice rend son propre Layout : le widget est démonté/remonté
 * à chaque navigation. Ce store module-level fait survivre la conversation et
 * l'état ouvert/fermé du panneau aux changements de page (perdu au refresh, voulu).
 */

import type { ChatState } from './chatReducer';

/** Durée de rétention d'une conversation (au-delà : repartir de zéro, éviter la surcharge mémoire) */
const CHAT_TTL_MS = 4 * 60 * 60 * 1000; // 4 heures

let savedState: ChatState | null = null;
let savedAt = 0;
let savedOpen = false;

export function saveChatState(state: ChatState): void {
  savedState = state;
  savedAt = Date.now();
}

export function loadChatState(): ChatState | null {
  if (savedState && Date.now() - savedAt > CHAT_TTL_MS) {
    savedState = null;
  }
  return savedState;
}

export function clearChatState(): void {
  savedState = null;
}

export function saveChatOpen(open: boolean): void {
  savedOpen = open;
}

export function loadChatOpen(): boolean {
  return savedOpen;
}
